import GrizzlyFeeder from './Grizzly-feeder-SW,-SV.png';
import GrizzlyFeeder2 from './Grizzly-feeder-SW,-SV_2.png';

export const getImageGrizzlyFeeder = () => {
  return GrizzlyFeeder;
};

export const getImageGrizzlyFeeder2 = () => {
  return GrizzlyFeeder2;
};
